import angular from 'angular';
import { Registration } from '../../registrations/model/registration';
import moment from 'moment';
import { guid1 } from '@/shared/utils/guid';

angular
  .module('cloudX')
  .controller('PlannedRegistrationDialogCtrl', [
    'resourceFactorySvc',
    'flySvc',
    '$translate',
    '$element',
    'close',
    'plannedReg',
    'relationId',
    'invoiceStreamId',
    'invoiceStreams',
    'crmType',
    plannedRegistrationDialogCtrl,
  ]);

function plannedRegistrationDialogCtrl(
  resourceFactorySvc,
  flySvc,
  $translate,
  $element,
  close,
  plannedReg,
  relationId,
  invoiceStreamId,
  invoiceStreams,
  crmType,
) {
  var vm = this;
  var resource = resourceFactorySvc.get('plannedRegistration');
  vm.regType = plannedReg && plannedReg.template ? plannedReg.template.type : null;
  vm.showValidation = false;
  vm.invoiceStreams = invoiceStreams;
  vm.inForfait = plannedReg && plannedReg.template ? plannedReg.template.inForfait : null;
  vm.inForfaitOptions = [
    { value: false, label: $translate.instant('ExcludedFromFixedAmountAdvance') },
    { value: true, label: $translate.instant('IncludedInFixedAmountAdvance') },
  ];

  vm.planned = plannedReg || {
    relationId: relationId,

    invoiceStreamId: invoiceStreamId,
    schedule: null,
    template: null,
    startDate: moment
      .utc()
      .add(1, 'days')
      .startOf('day')
      .toDate(),
    endDate: null,
  };
  vm.regSettings = {
    hideFromUntil: true,
    hidePriceDiscount: true,
    hideDate: true,
    hideInteractions: true,
    hideInForfait: true,
  };

  vm.dayMonthOptions = {
    minMode: 'day',
    maxMode: 'month',
    showWeeks: false,
    formatDayTitle: 'MMMM',
    datepickerMode: 'month',
    formatMonthTitle: ' ',
    initDate: moment
      .utc()
      .startOf('day')
      .set({
        year: 2000,
      })
      .toDate(),
    // minDate: new Date(2000, 0, 1),
    // maxDate: new Date(2000, 11, 31),
  };
  vm.startDateOptions = {
    minDate: moment
      .utc()
      .startOf('day')
      .add(1, 'days')
      .toDate(),
  };

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
    return '';
  };
  vm.regTypeChanged = function() {
    vm.planned.template = new Registration({
      relation: {
        id: relationId,
        invoiceStreamId: invoiceStreamId,
        crm: crmType,
      },
      invoiceStream: invoiceStreams.find(x => x.id === vm.planned.invoiceStreamId),
      ...(vm.planned.template || { userId: guid1 }),
      type: vm.regType,
      isBillable: true,
      resource: null,
      inForfait: null,
    });
  };
  vm.assignmentChanged = function() {
    vm.planned.template = new Registration({
      relation: {
        id: relationId,
        invoiceStreamId: invoiceStreamId,
        crm: crmType,
      },
      ...(vm.planned.template || { userId: guid1 }),
      invoiceStream: invoiceStreams.find(x => x.id === vm.planned.invoiceStreamId),
      invoiceStreamId: vm.planned.invoiceStreamId,
      inForfait: null,
    });
  };

  vm.schedules = [];
  resource.schedules(function(data) {
    vm.schedules = data;
  }, showError);

  vm.validateTemplate = function() {
    if (!vm.planned.template) return false;
    if (vm.planned.template.type < 0) return false;
    if (!vm.planned.template.resource) return false;
    if (vm.planned.template.type === 0 && vm.planned.template.durationMinutes <= 0) return false;
    if (vm.planned.template.type !== 0 && vm.planned.template.quantity <= 0) return false;
    return true;
  };

  vm.save = function() {
    if (vm.saving) return;
    var model = angular.copy(vm.planned);
    model.template.inForfait = vm.inForfait;
    // For the yearly schedule, set the month accordingly to easily use in back-end
    if (model.schedule.numberOfLines === 1) {
      model.day = model.date.getDate();
      model.month = model.date.getMonth() + 1; // getMonth() starts at 0
    }
    vm.saving = true;
    (vm.planned.id ? resource.update : resource.save)(
      {},
      model,
      function(result) {
        vm.saving = false;

        $element.modal('hide');
        close(result, 500);
      },
      function(error) {
        vm.saving = false;

        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };
  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
